import { useSessionStorage } from '@/utils/use-session-storage';
import { useEffect, useState } from 'react';
import { LinkTo } from './link-to';
import { IconInfo } from '@/assets/svg/icon-info';
import { Button } from './elements/button';
import { Trans } from '@lingui/macro';
import { styled, css } from '@/styles/stitches.config';

const Root = styled('section', {
  paddingInline: '$3',
  marginBlockStart: '$9',
  marginBlockEnd: 'calc(2 * $9)',
  variants: {
    isVisible: {
      true: {
        display: 'block',
      },
      false: {
        display: 'none',
      },
    },
  },
});

const Box = styled('div', {
  display: 'grid',
  maxWidth: '40ch',
  marginInline: 'auto',
  paddingBlock: '$4',
  paddingInline: '$5',
  backgroundColor: '$blue0',
  borderRadius: '$space$5',
  color: '$white',
});

export function SurveyBackground2023() {
  const [showSurveyBackground, setShowSurveyBackground] = useSessionStorage(
    'showSurveyBackground',
    true
  );

  const handleClick = async () => {
    setShowSurveyBackground(false);
  };

  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(showSurveyBackground);
  }, [showSurveyBackground]);

  return (
    <Root isVisible={isVisible}>
      <Box>
        <p>
          <Trans id="survey-background-2023.text">
            UNICEF + Gallup asked young + older people in 55 countries how they experience the world
            today.
          </Trans>
        </p>

        <LinkTo
          href="/about"
          css={{
            display: 'flex',
            alignItems: 'center',
            marginBlockEnd: '$4',

            '&:hover': {
              color: '$white',
            },

            '&:focus-visible, &.focus-visible': {
              outlineOffset: 3,
            },
          }}
        >
          <IconInfo className={css({ marginInlineEnd: '$2' })()} />
          <Trans id="survey-background.read-more">Read more about the survey</Trans>
        </LinkTo>

        <Button
          onClick={handleClick}
          css={{
            border: '1px solid $white',
            borderRadius: '$space$5',
            paddingBlock: '$2',
            paddingInline: '$4',
            fontSize: '$2',
            justifySelf: 'center',

            '&:hover': {
              backgroundColor: '$white',
              color: '$black',
            },

            '&: focus-visible &.focus-visible': {
              backgroundColor: '$white',
              color: '$black',
              outlineWidth: 3,
              outlineStyle: 'dotted',
              outlineColor: '$white',
            },
          }}
        >
          <Trans id="survey-background.dont-show-again">Don't show me this again</Trans>
        </Button>
      </Box>
    </Root>
  );
}
